import axios from 'axios'
import { Message, MessageBox } from 't-tyui'
import { getToken, removeToken, setToken, setCookie, getCookie, removeCookie } from './cookie'
import store from '../store/store'
import { resetIframeParams } from "@/utils/iframeUtils"




const consoleURL = process.env.VUE_APP_7_OPEN
const baseURL = process.env.VUE_APP_BASE_API
const buildPlatformTestObj = process.env.VUE_APP_X_Account


// 测试使用
if (!getToken() && process.env.NODE_ENV === 'dev') {
  try {
    const xToken = require("../../env-dev.local.js").xToken
    if (xToken) {
      setToken(xToken)
    }
  } catch (error) {
    console.log(error)
  }
}

// 重置一下iframe的信息
resetIframeParams()

// erp
if (window.location.href.includes('?token=')) {
  const token = window.location.href.split('token=')[1]
  setCookie('ERP-Token', token)
}

// 全局无权限提示唯一
sessionStorage.setItem('initMbox', 0)

const service = axios.create({
  baseURL,
  timeout: 50000, // 请求超时时间
  withCredentials: true,
  headers: {
    'X-Server-Name': 'tyun'
  }
})

// 统计接口返回610个数
// window._codeNum610 = 0
let _timeout610 = null

// request拦截,在请求发起前搞事情
service.interceptors.request.use((config) => {
  // config.data.UserID = 14320;
  config.headers['X-Server-Name'] = 'tyun'
  if (getToken()) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if (getCookie('ERP-Token')) {
    config.headers['ERP-Token'] = getCookie('ERP-Token')
  }
  if (!config.cancelToken) {
    config.cancelToken = new axios.CancelToken(function (cancel) {
      store.commit('pushToken', { cancelToken: cancel })
    })
  }
  // config.headers['X-Account'] = null //buildPlatformTestObj // 建平台开发测试使用
  return config
})

// response拦截,获取请求数据后，搞事情
service.interceptors.response.use(
  // 正常获取数据
  async response => {
    if (response.data && parseInt(response.data.code) === 610) {
      if (!_timeout610) {
        _timeout610 = setTimeout(() => {
          clearTimeout(_timeout610)
          _timeout610 = null
        }, 3000);
        Message({ type: 'error', message: response.data.message || response.data.msg })
        // return response
      }
      return Promise.reject(response)
      /*
        VUE_APP_CONSOLE_EMPTY_URL
        pre https://preconsole.marketingforce.com/620
        uat https://consoleuat.marketingforce.com/620
        prod https://console.marketingforce.com/620
      */
      // location.replace(process.env.VUE_APP_CONSOLE_EMPTY_URL)
      // return Promise.reject(response)
    }
    if (response.headers['content-type'] != null && response.headers['content-type'].indexOf('vnd.ms-excel') > 0) {
      return response
    }
    if (response.data && (response.data.code == 200 || response.data.code == 0)) { // code == 0 SCRM、外呼接口
      var arr = ['contactList', 'basicInfo', 'ad1', 'ad2', 'contactsNumV2', 'contactsNumBatchV2'] // 监听消耗条数的接口
      arr.forEach(e => {
        if (response.config.url.indexOf(e) > -1) {
          store.commit('SET_FREQUENCY', store.state.user.frequency + 1)
          // store.state.user.frequency = !store.state.user.frequency
        }
      })
      return response.data
    } else if (response.data.code === 402) {
      // 全局唯一判断提示， 因为有接口200 需要字段判断。 保证全局提示一次
      if (sessionStorage.getItem('initMbox') === '0') {
        sessionStorage.setItem('initMbox', 1)
        MessageBox.confirm('您当前账号无权限，请先购买后再登录操作', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          window.location.href = process.env.VUE_APP_OW_DOMAIN + 'item/235.html'
          sessionStorage.setItem('initMbox', 0)
        }).catch(() => { })
      }
    } else if (response.data.code === 403) {
      if (window.__sendIframeCodeMessage({ code: 403 })) return Promise.reject(response)
      // 抱歉，你无权访问该页面
      // router.push('/403')
      window.location.href = consoleURL + '403'
    } else {
      if (response.request.responseType === 'blob') {
        Message({ type: 'error', message: '没有权限访问，或者登录信息失效' })
      } else if (response.data.code === 401) {
        if (window.__sendIframeCodeMessage({ code: 401 })) return Promise.reject(response)
        if (process.env.NODE_ENV === 'erp' || process.env.NODE_ENV === 'erp-prod') {
          removeCookie('ERP-Token')
          window.location.href = consoleURL
        } else {
          removeToken('X-Token')
          window.location.href = consoleURL + 'login/login?backUrl=' + encodeURIComponent(window.location.href)
        }
      } else if (response.data.code > 200 && response.data.code < 300) {
        // 不显示报错弹框
        if (response.data.code === 203) {
          console.log(203, response, store)
          if (store.state.user.tel) {
            var msg = response.data.message.replace('[mobile]', store.state.user.tel)
            Message({ type: 'error', message: msg })
            return Promise.reject(response)
          }
        }
      } else if (response.data.code === 1511) {
        return response.data
      } else {
        const url = response.config.url
        const baseURL = response.config.baseURL
        const apiURL = url.replace(baseURL, '')
        // 当请求的接口是【获取可解析的域名】或者【获取实名认证】的时候，不需要弹框
        if (apiURL !== 'aggregateservice-web/api/User_Domain/GetAnalysisDomainListNew' && apiURL !== 'tcloud-account/authentication/selectAuthenticationInfoStatus' && apiURL !== 'tcloud-account/account/checkUserFirstLogin') {
          Message({ type: 'error', message: response.data.message || response.data.msg })
        }
      }
      return Promise.reject(response)
    }
  },
  // 请求失败
  error => {
    console.log('请求错误', error)
    // new Error('error')
    return Promise.reject('error')
  },
)

export default service
